export type StoreProduct = {
  id: string;
  name: string;
  description: string;
  price: number;
};

export type StoreMerchant = {
  id: string;
  name: string;
  paymentMerchantName: string;
  category: string;
  estiaMerchantId?: string;
  products: StoreProduct[];
};

export const DUMMY_STORE_MERCHANTS: StoreMerchant[] = [
  {
    id: "merchant-coffee",
    name: "Urban Bean Coffee",
    paymentMerchantName: "My Company",
    category: "Cafe",
    estiaMerchantId: "d09b1d67-261b-4bae-84ec-4259c9a7c500",
    products: [
      { id: "coffee-latte", name: "Iced Latte", description: "Double espresso with cold milk", price: 4.5 },
      { id: "coffee-mocha", name: "Mocha", description: "Chocolate espresso drink", price: 5.2 },
    ],
  },
  {
    id: "merchant-books",
    name: "Blue Harbor Books",
    paymentMerchantName: "My Company",
    category: "Books",
    estiaMerchantId: "d09b1d67-261b-4bae-84ec-4259c9a7c500",
    products: [
      { id: "book-clean-code", name: "Clean Code", description: "Robert C. Martin", price: 34.99 },
      { id: "book-ddd", name: "Domain-Driven Design", description: "Eric Evans", price: 44.5 },
    ],
  },
  {
    id: "merchant-gear",
    name: "Nomad Tech Gear",
    paymentMerchantName: "My Company",
    category: "Electronics",
    estiaMerchantId: "d09b1d67-261b-4bae-84ec-4259c9a7c500",
    products: [
      { id: "gear-charger", name: "65W Charger", description: "USB-C GaN fast charger", price: 29.9 },
      { id: "gear-cable", name: "Braided USB-C Cable", description: "2m durable cable", price: 14.9 },
    ],
  },
];
